import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action,
  className,
}) => {
  return (
    <div className={cn(
      "flex flex-col items-center justify-center p-8 text-center",
      className
    )}>
      {Icon && (
        <div className="mb-4 rounded-full bg-[var(--neutral-gray-10)] p-3">
          <Icon className="h-6 w-6 text-[var(--neutral-gray-70)]" />
        </div>
      )}
      <h3 className="text-sm font-semibold text-[var(--neutral-gray-110)]">{title}</h3>
      {description && (
        <p className="mt-1 text-xs text-[var(--neutral-gray-80)] max-w-[240px]">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};
